<template>
  <v-container id="pick-pack-ships-table" fluid>
    <v-card outlined :disabled="loadingData">
      <v-data-table
        :headers="computedHeaders"
        :items="pickPackShips"
        :options.sync="options"
        :server-items-length="totalPickPackShips"
        :footer-props="footerProps"
        :loading="loadingData"
        :loading-text="$t('subOrder.getPickPackShipsInProgress')"
        :no-data-text="$t('subOrder.noPickPackShip')"
        mobile-breakpoint="650"
        item-key="id"
        dense
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.sub_orders="{ item }">
          {{ item.sub_orders.map((subOrder) => subOrder.order_id).join(', ') }}
        </template>

        <template v-slot:item.created_at="{ item }">
          <span>{{ new Date(item.created_at) | moment('DD/MM/YYYY HH:mm:ss') }}</span>
        </template>
        getStatus
        <template v-slot:item.current_status="{ item }">
          <span>{{ getStatusTranslation(item.current_status) }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn :class="[!isMobile ? '' : 'pr-0']" color="primary" text @click="executeAction(item._id)">
            <v-icon v-if="$vuetify.breakpoint.width >= 650 && $vuetify.breakpoint.width <= 768">mdi-magnify</v-icon>
            <span v-else>{{ $t('subOrder.resume') }}</span>
          </v-btn>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card>
  </v-container>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { EventBus } from '../../event-bus'

  export default {
    name: 'PickPackShipsTable',
    data() {
      return {
        pickPackShips: [],
        totalPickPackShips: 0,
        options: {
          itemsPerPage: 15,
          sortDesc: [],
          sortBy: [],
        },
        loadingData: false,
        componentPreviousPath: '',
        headersMobile: [
          {
            text: this.$t('subOrder.creationDate'),
            value: 'created_at',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.subOrders'),
            value: 'sub_orders',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.picker'),
            value: 'picker',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.packer'),
            value: 'packer',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.currentStatus'),
            value: 'current_status',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.currentStep'),
            value: 'current_step',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.date'),
            value: 'created_at',
            filterType: 'text',
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ],
        headers: [
          {
            text: this.$t('subOrder.creationDate'),
            value: 'created_at',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.preparationOrders'),
            value: 'sub_orders',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.picker'),
            value: 'picker',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.packer'),
            value: 'packer',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.currentStatus'),
            value: 'current_status',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.currentStep'),
            value: 'current_step',
            filterType: 'text',
          },
          {
            text: this.$t('subOrder.creationDate'),
            value: 'created_at',
            filterType: 'text',
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ],
      }
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
      $props: {
        // any change on props reload datas, use separate watcher for each prop did not work (double event)
        handler() {
          if (this.$store.state.previousPath.split('/')[1] === 'bins') {
            this.pickPackShips = []
            this.list()
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      ...mapState(['loading', 'currentStore', 'isCustomerService']),
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('subOrder.pickPackShipsPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('subOrder.sortByText'),
        }
      },
      computedHeaders() {
        if (this.isMobile) {
          return this.headersMobile
        } else {
          return this.headers
        }
      },
    },
    methods: {
      ...mapMutations({
        setLoading: 'SET_LOADING',
      }),
      executeAction: function (pickPackShipId) {
        this.$router.push({
          path: `bins/${pickPackShipId}`,
        })
      },
      list() {
        this.loadingData = true
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.getPickPackShipsInProgress'),
        })
        let { page, itemsPerPage, sortDesc, sortBy } = this.options
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy.length === 0 ? '_id' : sortBy,
            sortDesc: sortDesc.length === 0 ? true : sortDesc,
            location_id: this.isCustomerService ? undefined : [this.currentStore],
            status: ['picking', 'packing'],
          },
        }
        this.$Amplify.API.get('pick-pack-ships', '/v1/int/pick-pack-ships', myInit)
          .then((res) => {
            this.pickPackShips = res.data
            this.totalPickPackShips = res.nbPickPackShips
            this.loadingData = false
            if (this.totalPickPackShips < (this.options.page - 1) * this.options.itemsPerPage + 1) {
              let pageNumber = Math.floor(this.totalPickPackShips / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
          })
          .catch((e) => {
            this.loadingData = false
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('subOrder.errorLoadingPickPackShips'),
              color: 'error',
            })
          })
        EventBus.$emit('displayGlobalOverlay', { display: false })
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        EventBus.$emit('reLoadCounter')
        this.list()
      },
      getStatusTranslation(status) {
        const statusTranslation = [
          { text: this.$t('subOrder.finished'), value: 'finished' },
          { text: this.$t('subOrder.picking'), value: 'picking' },
          { text: this.$t('subOrder.packing'), value: 'packing' },
        ]

        // Find the corresponding translation
        const translatedStatus = statusTranslation.find((item) => item.value === status)

        // Return the translated text if found, otherwise return the original status
        return translatedStatus ? translatedStatus.text : status
      },
    },
    // we save the current path, to have it when this component will be reused later
    beforeRouteLeave(to, from, next) {
      this.componentPreviousPath = from.path
      next()
    },
  }
</script>
